import * as http from '~/utils/apis';

const togglePublishedState = async (id) => {
    await http.patch(`cms-api/published-state/${id}`);
};

export default togglePublishedState;
